import type { helpWidgetItemOnViewNewSrc4Evid1505Params } from '@wix/bi-logger-customer-care-data/v2/types';

import { TRootState } from '../common/reducers';
import { selectWidgetExpanded } from '../common/selectors/widget';
import { biLogger } from './biLogger';

export async function reportItemOnViewWhenExpanded(
  state: TRootState,
  params: Partial<helpWidgetItemOnViewNewSrc4Evid1505Params>,
): Promise<boolean> {
  const isWidgetExpanded = selectWidgetExpanded(state);
  if (!isWidgetExpanded) {
    return false;
  }
  await biLogger.helpWidgetItemOnViewNew(state, params);
  return true;
}
